
// ASSETS
import logo from '../../assets/images/Favicon.png';

// STYLE
import './css/loading.css';

export const Loading = () => {
    return (
        <div className="loading">
            <img src={logo} id="img-loading" />
            <h1 className="text-loading">Carregando...</h1>
        </div>
    )
}